module.exports = __webpack_public_path__ + "static/media/07tGpPe3i4F68L0tyXv3myR-1.fit_lim.v1760032080.666fc19e.png";